// extracted by mini-css-extract-plugin
module.exports = {"team-banner":"team-env-banner_team-banner__e_Ao1","close-button":"team-env-banner_close-button__XTbbJ"};